const mapFilters = {
  search: 'keyword',
  kind: 'kind',
  'category[]': 'categories',
  'brand[]': 'brands',
  model: 'model',
  'models[]': 'models',
  'exchange[]': 'transmissions',
  'color[]': 'colors',
  min_price: 'min_price',
  max_price: 'max_price',
  min_km: 'min_km',
  max_km: 'max_km',
  min_model_year: 'min_model_year',
  max_model_year: 'max_model_year',
  'unit_id[]': 'units',
  unit_state: 'state',
  unit_city: 'city',
  sort: 'sort',
  shielded: 'shielded'
}

export const parseFiltersStoreStateToComponentState = (storeFiltersState) => {
  const parsedFilter = storeFiltersState.map(filter => {
    const filterKey =  Object.keys(filter)[0]
    const filterValue = Object.values(filter)[0]

    const isAnArrayFilter = filterKey.includes('[]')
    const parsedFilterValue = isAnArrayFilter ? filterValue.split(',') : filterValue

    const mappedFilterKey = mapFilters[filterKey]

    return {
      [mappedFilterKey]: parsedFilterValue
    }
  })

  const parsedFilterObject = parsedFilter.reduce((filterObject, currentFilter) => {
    return {...filterObject, ...currentFilter}
  }, {})

  return parsedFilterObject
}
